import { gql } from '@apollo/client';

import { TARGETING_RULE_DEFINITION } from '../../../../apis/graphql';
import { ADS_PAGE_AD } from '../../../../common/AdForm/hooks/fragments';

export const CREATE_ADS_PAGE_AD = gql`
  mutation CreateAdsPageAd($adInput: AdInputV5!) {
    createAd: createAdV5(input: $adInput) {
      ...adsPageAd
    }
  }
  ${ADS_PAGE_AD}
`;

export const CREATE_ADS_PAGE_AD_WITH_ASSET = gql`
  mutation CreateAdsPageAdWithAsset(
    $adInput: AdInputV5!
    $assetId: ID!
    $countryCodes: [String!]
    $creativeLibraryId: String!
  ) {
    createAd: createAdV5(input: $adInput) {
      ...adsPageAd
    }
    updateReviewAsset(assetId: $assetId, countryCodes: $countryCodes, creativeLibraryId: $creativeLibraryId) {
      id
    }
  }
  ${ADS_PAGE_AD}
`;

export const CREATE_AD_WITH_BATCH_ASSETS = gql`
  mutation CreateAdWithBatchAssets(
    $adInput: AdInputV5!
    $idList: [String!]!
    $countryCodes: [String!]
    $creativeLibraryId: String!
  ) {
    createAd: createAdV5(input: $adInput) {
      ...adsPageAd
    }

    updateBatchReviewAssets(idList: $idList, countryCodes: $countryCodes, creativeLibraryId: $creativeLibraryId) {
      successful {
        id
      }
      failed {
        id
        message
      }
    }
  }
  ${ADS_PAGE_AD}
  ${TARGETING_RULE_DEFINITION}
`;

export const CREATE_AD_WITH_GATEWAY_ASSETS = gql`
  mutation CreateAdWithGatewayAssets(
    $adInput: AdInputV5!
    $displayAssetId: String!
    $displayAssetCountryCodes: [String!]
    $videoAssetId: String!
    $videoAssetCountryCodes: [String!]
    $creativeLibraryId: String!
  ) {
    createAd: createAdV5(input: $adInput) {
      ...adsPageAd
    }

    updateDisplayAsset: updateBatchReviewAssets(
      idList: [$displayAssetId]
      countryCodes: $displayAssetCountryCodes
      creativeLibraryId: $creativeLibraryId
    ) {
      successful {
        id
      }
      failed {
        id
        message
      }
    }
    updateVideoAsset: updateBatchReviewAssets(
      idList: [$videoAssetId]
      countryCodes: $videoAssetCountryCodes
      creativeLibraryId: $creativeLibraryId
    ) {
      successful {
        id
      }
      failed {
        id
        message
      }
    }
  }
  ${ADS_PAGE_AD}
`;

export const UPDATE_ADS_PAGE_AD = gql`
  mutation UpdateAdsPageAd($adId: ID!, $updateAdInput: UpdateAdInputV5!, $targetingRule: TargetingRuleInput) {
    updateAd: updateAdV5(id: $adId, input: $updateAdInput, targetingRule: $targetingRule) {
      ...adsPageAd
      targetingRule {
        ...targetingRuleDefinition
      }
    }
  }
  ${ADS_PAGE_AD}
  ${TARGETING_RULE_DEFINITION}
`;

export const UPDATE_ADS_PAGE_AD_WITH_ASSET = gql`
  mutation UpdateAdsPageWithAsset(
    $adId: ID!
    $updateAdInput: UpdateAdInputV5!
    $assetId: ID!
    $countryCodes: [String!]
    $targetingRule: TargetingRuleInput
    $creativeLibraryId: String!
  ) {
    updateAd: updateAdV5(id: $adId, input: $updateAdInput, targetingRule: $targetingRule) {
      ...adsPageAd
      targetingRule {
        ...targetingRuleDefinition
      }
    }
    updateReviewAsset(assetId: $assetId, countryCodes: $countryCodes, creativeLibraryId: $creativeLibraryId) {
      id
    }
  }
  ${ADS_PAGE_AD}
  ${TARGETING_RULE_DEFINITION}
`;

export const UPDATE_AD_WITH_BATCH_ASSETS = gql`
  mutation UpdateAdWithBatchAssets(
    $adId: ID!
    $updateAdInput: UpdateAdInputV5!
    $assetIdList: [String!]!
    $countryCodes: [String!]
    $targetingRule: TargetingRuleInput
    $creativeLibraryId: String!
  ) {
    updateAd: updateAdV5(id: $adId, input: $updateAdInput, targetingRule: $targetingRule) {
      ...adsPageAd
      targetingRule {
        ...targetingRuleDefinition
      }
    }

    updateBatchReviewAssets(idList: $assetIdList, countryCodes: $countryCodes, creativeLibraryId: $creativeLibraryId) {
      successful {
        id
      }
      failed {
        id
        message
      }
    }
  }
  ${ADS_PAGE_AD}
  ${TARGETING_RULE_DEFINITION}
`;

export const UPDATE_AD_WITH_GATEWAY_ASSETS = gql`
  mutation UpdateAdWithGatewayAssets(
    $adId: ID!
    $updateAdInput: UpdateAdInputV5!
    $targetingRule: TargetingRuleInput
    $displayAssetId: String!
    $displayAssetCountryCodes: [String!]
    $videoAssetId: String!
    $videoAssetCountryCodes: [String!]
    $creativeLibraryId: String!
  ) {
    updateAd: updateAdV5(id: $adId, input: $updateAdInput, targetingRule: $targetingRule) {
      ...adsPageAd
      targetingRule {
        ...targetingRuleDefinition
      }
    }

    updateDisplayAsset: updateBatchReviewAssets(
      idList: [$displayAssetId]
      countryCodes: $displayAssetCountryCodes
      creativeLibraryId: $creativeLibraryId
    ) {
      successful {
        id
      }
      failed {
        id
        message
      }
    }
    updateVideoAsset: updateBatchReviewAssets(
      idList: [$videoAssetId]
      countryCodes: $videoAssetCountryCodes
      creativeLibraryId: $creativeLibraryId
    ) {
      successful {
        id
      }
      failed {
        id
        message
      }
    }
  }
  ${ADS_PAGE_AD}
  ${TARGETING_RULE_DEFINITION}
`;
